function sleep(ms) {
    return new Promise((val) => setTimeout(val, ms));
}

async function fetchWithStatus(apiUrl, retryAfter, statusUpdateCallback) {
    let doReFetch = true;
    let finalResponseJson;

    while (doReFetch) {
        await sleep(retryAfter);

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            const message = `An error has occurred: ${response.status}`;
            throw new Error(message);
        }

        const responseJson = await response.json();

        const hasStatus = Boolean(responseJson.status);

        if (hasStatus) {
            statusUpdateCallback(responseJson);
        } else {
            finalResponseJson = responseJson;
            doReFetch = false;
        }
    }

    return finalResponseJson;
}

export { fetchWithStatus };
